import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames,
  getCouponsAPI,
  addCouponAPI,
  updateCouponAPI,
  deleteCouponAPI,
  activateDeactivateCouponAPI,
  getCouponByIdAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Subscription Table Column Names
export const fetchCouponTableColumns = createAsyncThunk(
  "coupon/fetchCouponTableColumns",
  async (subscription, thunkAPI) => {
    try {
      const response = await getTableColumnNames(subscription);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Subscription
export const fetchAllCoupons = createAsyncThunk(
  "coupon/fetchCoupons",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCouponsAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching coupons");
    }
  }
);

// Add Subscription
export const addCoupon = createAsyncThunk(
  "coupon/addCoupon",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await addCouponAPI(subscription);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding coupon");
    }
  }
);

// Update Subscription
export const updateCoupon = createAsyncThunk(
  "coupon/updateCoupon",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await updateCouponAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating coupon");
    }
  }
);

// Delete Subscription
export const deleteCoupon = createAsyncThunk(
  "coupon/deleteCoupon",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await deleteCouponAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting coupon");
    }
  }
);

// Active Deactive Subscription
export const activateDeactivateCoupon = createAsyncThunk(
  "coupon/activateDeactivateCoupon",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateCouponAPI(subscription);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating coupon");
    }
  }
);

// fetch Coupon by ID
export const fetchCouponById = createAsyncThunk(
  "coupon/fetchCouponById",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await getCouponByIdAPI(subscription);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching coupon by ID");
    }
  }
);